import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from "rxjs";
import { AuthService } from "../services/auth.service";


@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

    private authService = inject(AuthService);
    private router = inject(Router);
    private isRefreshing = false;
    private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && error.status === 401) {
                    if (!req.url.includes('/login')  && !req.url.includes('/refresh')) {
                        return this.handle401Error(req, next);
                    } else {
                        return throwError(() => error);
                    }

                } else if (error instanceof HttpErrorResponse && error.status === 403) {
                    this.router.navigate(['/forbidden']);
                    return throwError(() => error);
                } else {
                    return throwError(() => error);
                }
            })
        )
    }

    private addToken(request: HttpRequest<any>, token: string) {
        return request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        });
      }


    private handle401Error(req: HttpRequest<any>, next: HttpHandler) {
        if (!this.isRefreshing) {
            this.isRefreshing = true;
            this.refreshTokenSubject.next(null);

            return this.authService.refreshToken().pipe(
                switchMap((token: any) => {
                    this.isRefreshing = false;
                    this.refreshTokenSubject.next(token.accessToken);
                    return next.handle(this.addToken(req, token.accessToken));
                }),
                catchError(error => {
                    this.isRefreshing = false;
                    this.authService.logout();
                    this.router.navigate(['/login']);
                    return throwError(() => error);
                })
            )
        } else {
            return this.refreshTokenSubject.pipe(
                filter(token => token != null),
                take(1),
                switchMap(accessToken => {
                    return next.handle(this.addToken(req, accessToken));
                })
            )
        }
    }
}
